import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router/dist/vue-router.js'
import routes from './routes.js';
import Transitions from 'vue2-transitions'
// import ckeditor from 'ckeditor'

import { store } from './store.js';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPlusCircle,
  faMinusCircle,
  faCartPlus,
  faShoppingCart,
  faShoppingBag,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronRight,
  faChevronLeft,
  faEyeSlash,
  faEye,
  faCreditCard,
  faEnvelope,
  faA,
  faPhone,
  faCircleUser,
  faBars,
  faAddressCard,
  faClose,
  faTags,
  faHome,
  faIndustry,
  faUser,
  faSearch,
  faChevronDown,
  faGlobe,
  faBox,
  faMapMarkerAlt,
  faCamera
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebook,
  faInstagram,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

import VueAffix from 'vue-affix'

Vue.use(VueAffix)
Vue.use(VueRouter)
Vue.use(Transitions)
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import './assets/styles/fontawesome.css';
import './assets/styles/all.min.css';
import './assets/styles/svg-with-js.min.css';
import './assets/styles/solid.min.css';
import './assets/styles/regular.min.css';
import './assets/styles/brands.min.css';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

const router = new VueRouter({
  routes,
  mode: 'history'
})

library.add(
  faIndustry,
  faHome,
  faTags,
  faClose,
  faPhone,
  faAddressCard,
  faBars,
  faCircleUser,
  faPlusCircle,
  faMinusCircle,
  faCartPlus,
  faShoppingCart, faShoppingBag,
  faChevronCircleDown, faChevronCircleUp, faChevronRight, faChevronLeft,
  faEyeSlash, faEye, faCreditCard, faEnvelope, faA, faPhone,
  faUser, faFacebook, faInstagram,
  faSearch, faChevronDown, faGlobe, faWhatsapp, faBox,
  faMapMarkerAlt, faCamera)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.filter('toUSD', (value) => `$${value.toFixed(3)}`)

Vue.config.productionTip = false


window.Vue = new Vue({
  render: h => h(App),
  router,
  store,
  data() {
    return {
      loading: true
    }
  },
  created() {
    this.$store.dispatch("setUpStore")
  },
  mounted() {
    this.loading = false
  }
}).$mount('#app')